import { createContext, useState } from "react";

export const ForeignerPersonalContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [foreignerPersonals, setForeignerPersonals] = useState([]);
    const [foreignerPersonal, setForeignerPersonal] = useState([]);
    const [foreignerPersonalHistories, setForeignerPersonalHistories] = useState([]);
    const [foreignerPersonalDialog, setForeignerPersonalDialog] = useState(false);
    const [foreignerPersonalHistoryDialog, setForeignerPersonalHistoryDialog] = useState(false);

    // Make the context object:
    const foreignerPersonalContext = {
        foreignerPersonals,
        setForeignerPersonals,
        foreignerPersonal,
        setForeignerPersonal,
        foreignerPersonalDialog,
        setForeignerPersonalDialog,
        foreignerPersonalHistories,
        setForeignerPersonalHistories,
        foreignerPersonalHistoryDialog,
        setForeignerPersonalHistoryDialog,
    };

    // pass the value in provider and return
    return <ForeignerPersonalContext.Provider value={foreignerPersonalContext}>{children}</ForeignerPersonalContext.Provider>;
};

export const { Consumer } = ForeignerPersonalContext;
